import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';

// Utility function to truncate text after 20 words
const truncateText = (text, wordLimit) => {
  if (!text) return 'N/A';
  const words = text.split(' ');
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(' ') + '...'
    : text;
};

const SymptomDetailsPopup = ({ selectedSymptom, onClose }) => {
  return (
    <div className="z-5 fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="relative h-auto w-full max-w-2xl overflow-y-auto rounded-3xl bg-white p-8 shadow-xl transition-all duration-300 ease-in-out">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-3xl text-gray-400 hover:text-gray-600 focus:outline-none"
        >
          &times;
        </button>

        {/* Symptom Details */}
        <div className="space-y-6">
          {/* Title */}
          <h2 className="mb-6 text-center text-2xl font-bold text-gray-800">
            Symptom Details
          </h2>

          {/* Symptom Info */}
          <div className="grid grid-cols-2 gap-6">
            {/* Symptom ID */}
            <div className="flex flex-col">
              <span className="font-medium text-gray-500">Symptom ID</span>
              <span className="break-words text-lg font-semibold text-gray-800">
                {selectedSymptom.hpoid || 'N/A'}
              </span>
            </div>

            {/* Symptom Name */}
            <div className="flex flex-col">
              <span className="font-medium text-gray-500">Name</span>
              <span className="break-words text-lg font-semibold text-gray-800">
                {selectedSymptom.name || 'N/A'}
              </span>
            </div>

            {/* Symptom Synonyms */}
            <div className="col-span-2 flex flex-col">
              <span className="font-medium text-gray-500">Synonyms</span>
              <span className="break-words text-lg font-normal text-gray-800">
                {truncateText(selectedSymptom.synonyms, 20)}
              </span>
            </div>

            {/* Symptom Comment */}
            <div className="col-span-2 flex flex-col">
              <span className="font-medium text-gray-500">Comment</span>
              <span className="break-words text-lg font-normal text-gray-800">
                {truncateText(selectedSymptom.comment, 20)}
              </span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 flex justify-center">
          <button
            onClick={onClose}
            className="rounded-full bg-blue-500 px-8 py-2 text-white transition-colors hover:bg-blue-600 focus:ring-4 focus:ring-blue-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SymptomDetailsPopup;
